import { render, staticRenderFns } from "./textBookCenter.vue?vue&type=template&id=4fd7122c&scoped=true"
import script from "./textBookCenter.vue?vue&type=script&lang=js"
export * from "./textBookCenter.vue?vue&type=script&lang=js"
import style0 from "./textBookCenter.vue?vue&type=style&index=0&id=4fd7122c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd7122c",
  null
  
)

export default component.exports